
import Maps from '../maps.json'

const FloorLegend = ({mapIndex, floorIndex}) => {

    const sharedSpaces = Maps.maps[mapIndex].floors[floorIndex].spaces.filter((space) => space.type === "shared");
    const privateSpaces = Maps.maps[mapIndex].floors[floorIndex].spaces.filter((space) => space.type === "private");
    const freeSpaces = Maps.maps[mapIndex].floors[floorIndex].freeSpaces;

    return(
        <div className="font-lekton bg-[white] max-h-[50vh] max-w-[60vw] overflow-auto opacity-50 border-8 border-[#ffd900] p-2 whitespace-nowrap max-sm:hidden">
            <div>
                <p className='text-sm font-bold'> Spazi Disponibili [{freeSpaces.length}]</p>
                {freeSpaces.map((space,index) => <p key={index} className='text-xs'>[{index +1}] {space.title}</p>)}
            </div>
            <div>
                <div>
                    <div>
                        <p className='text-sm font-bold'> Spazi Comuni [{sharedSpaces.length}]</p>
                        {sharedSpaces.map((space,index) => <p key={index} className='text-xs'>[{index +1}] {space.title}</p>)}
                    </div>
                    <div>
                        <p className='text-sm font-bold'> Spazi Soci [{privateSpaces.length}]</p>
                        {privateSpaces.map((space,index) => <p key={index} className='text-xs'>[{index +1}] {space.title}</p>)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FloorLegend